import { HeadingExtension as RmHeadingExtension } from 'remirror/extensions';

export class HeadingExtension extends RmHeadingExtension {
  index = 0;
  createNodeSpec(extra, override) {
    const baseSpec = super.createNodeSpec(extra, override);
    return {
      ...baseSpec,
      attrs: {
        ...baseSpec.attrs,
        id: { default: null },
      },
      parseDOM: [
        {
          tag: 'h1, h2, h3, h4, h5, h6',
          getAttrs: (dom) => ({
            level: parseInt(dom.tagName[1]),
            id: dom.getAttribute('id') || `${Date.now()}-${Math.random().toString(36).substring(2, 8)}`,
          }),
        },
      ],
      toDOM: (node) => {
        const level = node.attrs.level;
        let id = node.attrs.id || null;
        if (id === null) {
          id =
            String(node.textContent)
              .replace(/[^\w\s]/g, '')
              .trim()
              .replace(/^_+|_+$/g, '')
              .replace(/\s+/g, '_') + this.index.toString();
          this.index = this.index + 1;
        }
        return [`h${level}`, { ...node.attrs, id, 'data-heading-id': id, 'data-heading-level': level }, 0];
      },
    };
  }

  createInputRules() {
    const rules = super.createInputRules();
    return rules.map((rule) => {
      const originalHandler = rule.handler;
      return {
        ...rule,
        handler: (state, match, start, end) => {
          const tr = originalHandler(state, match, start, end);
          if (tr) {
            const pos = tr.selection.$from.before();
            const node = tr.doc.nodeAt(pos);
            if (node?.type.name === 'heading' && !node.attrs.id) {
              const id = `${Date.now()}-${Math.random().toString(36).substring(2, 8)}`;
              tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                id,
              });
            }
          }
          return tr;
        },
      };
    });
  }
}

export default HeadingExtension;
